<template>
  <div class="warp">
    <div class="transfer">
      <img
        src="https://game.leiting.com/static/client/images/transfer_android.png"
        alt=""
        style="width: 100%"
      />
    </div>
  </div>
</template>
<script>
import { isAndroid } from "@utils/index";
import { mapGetters } from "vuex";

var ua = window.navigator.userAgent.toLowerCase();

export default {
  computed: mapGetters(["initData", "downloadUrl"]),
  mounted: function() {
    window.$("#LT_age").remove();
    this.$store.dispatch("GET_INIT");
    setTimeout(() => {
      if (this.isWeiXin() || this.isWeibo()) {
        //微信或微博访问，提示用外部浏览器打开
        // do nothing
      } else {
        console.log("downloadUrl", isAndroid(), this.downloadUrl);
        const { android_url, ios_url } = this.downloadUrl;
        if (android_url || ios_url) {
          window.location.assign(isAndroid() ? android_url : ios_url);
        }
        //非微信访问，直接推送地址
        window.$(".warp").css("display", "none");
      }
    }, 500);
  },
  methods: {
    isWeiXin() {
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    isWeibo() {
      if (ua.indexOf("weibo") > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
